/* LUMLY · Anteprima LED: ogni linea disegnata come una matrice di LED.
   Al passaggio del mouse i LED si accendono attorno al cursore e cambiano colore. */
(function () {
  if (window.__lwMatrix) return; window.__lwMatrix = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* forma di ciascuna linea: proporzioni del pannello, passo dei LED, tipo */
  var SHAPES = {
    wall:   { ar: 16 / 9, w: .78, gap: 7,  kind: 'rect', seam: 8 },
    slim:   { ar: 2,      w: .80, gap: 6,  kind: 'rect', seam: 0, edge: 1 },
    glass:  { ar: 3 / 4,  w: .46, gap: 9,  kind: 'rect', seam: 0, frame: 1, sparse: 1 },
    sphere: { ar: 1,      w: .62, gap: 7,  kind: 'circle' },
    stage:  { ar: 3,      w: .84, gap: 7,  kind: 'rect', seam: 6, floor: 1 },
    totem:  { ar: 1 / 3,  w: .22, gap: 6,  kind: 'rect', seam: 0, foot: 1 }
  };
  var all = [], io = null;

  function Matrix(box) {
    var type = box.getAttribute('data-lw3d'); this.sh = SHAPES[type] || SHAPES.wall;
    /* con il passo pixel del modello la densità dei LED è proporzionale a quella reale */
    this.pitch = parseFloat(box.getAttribute('data-pitch')) || 0;
    this.box = box; this.dots = []; this.on = false; this.hover = 0; this.hoverT = 0;
    this.px = -1e4; this.py = -1e4; this.hue = 38; this.waves = [];
    var c = this.cv = document.createElement('canvas');
    c.className = 'lw3d__mx'; c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;cursor:default';
    box.appendChild(c); box.classList.add('is-3d');
    this.g = c.getContext('2d');
    var self = this;
    if (!RM) {
      var host = box.closest('a,article,.lwl-card,.lcc') || box;
      host.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (self.px > -1e3) self.hue = (self.hue + Math.min(40, Math.hypot(x - self.px, y - self.py)) * 0.35) % 360;
        self.px = x; self.py = y; self.hover = 1; self.wake();
      });
      host.addEventListener('pointerenter', function (e) {
        var r = c.getBoundingClientRect(); self.waves.push({ x: e.clientX - r.left, y: e.clientY - r.top, t: performance.now() }); self.wake();
      });
      host.addEventListener('pointerleave', function () { self.hover = 0; self.px = self.py = -1e4; });
    }
    this.size();
  }
  Matrix.prototype.size = function () {
    var r = this.box.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
    var W = this.W = Math.max(1, r.width), H = this.H = Math.max(1, r.height), sh = this.sh;
    this.cv.width = Math.round(W * dpr); this.cv.height = Math.round(H * dpr);
    this.g.setTransform(dpr, 0, 0, dpr, 0, 0);
    var pw = W * (this.pitch && sh.kind !== 'circle' && sh.ar >= 1 ? Math.max(sh.w, .84) : sh.w), ph = pw / sh.ar;
    var cap = this.pitch ? .8 : .72; if (ph > H * cap || (this.pitch && sh.ar < 1)) { ph = H * cap; pw = ph * sh.ar; }
    var x0 = (W - pw) / 2, y0 = (H - ph) / 2 - (sh.foot ? H * .03 : 0), gap = this.pitch ? Math.max(3.4, Math.min(15, this.pitch * (sh.sparse ? 1.25 : 1.9))) : sh.gap * (W < 320 ? .85 : 1);
    this.rect = { x: x0, y: y0, w: pw, h: ph };
    /* i cabinet: una fuga sottile ogni "seam" file di LED */
    var se = sh.seam ? gap * .5 : 0, span = function (n) { return (n - 1) * gap + (sh.seam ? Math.floor((n - 1) / sh.seam) * se : 0); };
    var nx = Math.floor(pw / gap) + 1, ny = Math.floor(ph / gap) + 1;
    while (nx > 2 && span(nx) > pw) nx--; while (ny > 2 && span(ny) > ph) ny--;
    var ox = x0 + (pw - span(nx)) / 2, oy = y0 + (ph - span(ny)) / 2;
    var d = this.dots = [], cx = W / 2, cy = y0 + ph / 2, rr = Math.min(pw, ph) / 2;
    for (var j = 0; j < ny; j++) for (var i = 0; i < nx; i++) {
      var x = ox + i * gap + (sh.seam ? Math.floor(i / sh.seam) * se : 0), y = oy + j * gap + (sh.seam ? Math.floor(j / sh.seam) * se : 0);
      if (sh.kind === 'circle' && Math.hypot(x - cx, y - cy) > rr - gap * .3) continue;
      if (sh.sparse && (i + j) % 2) continue;
      /* luce che arriva dall'alto a sinistra: dà volume al pannello */
      var L, S = 1;
      if (sh.kind === 'circle') {
        var qx = (x - cx) / rr, qy = (y - cy) / rr, qz = Math.sqrt(Math.max(0, 1 - qx * qx - qy * qy));
        L = .3 + 1.1 * Math.max(0, -.45 * qx - .55 * qy + .7 * qz); S = .45 + .55 * Math.sqrt(qz);
      } else { L = 1.3 - .45 * (i / nx * .55 + j / ny * .45); }
      d.push(x, y, i / nx, j / ny, L * S, S);
    }
    this.rad = gap * (sh.sparse ? .2 : .26);
    this.body();
    this.draw(performance.now());
  };
  /* corpo del pannello: ombra a terra, spessore e riflesso sul bordo (disegnati una volta) */
  Matrix.prototype.body = function () {
    var W = this.W, H = this.H, R = this.rect, sh = this.sh, dpr = Math.min(2, window.devicePixelRatio || 1);
    var b = this.bg || (this.bg = document.createElement('canvas'));
    b.width = Math.round(W * dpr); b.height = Math.round(H * dpr);
    var g = b.getContext('2d'); g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, W, H);
    var base = R.y + R.h + (sh.foot ? 20 : sh.floor ? 16 : 0), round = sh.kind === 'circle';
    /* ombra morbida a terra */
    var fy = round ? R.y + R.h + R.h * .12 : base + 14, fw = R.w * (round ? .42 : .56);
    g.save(); g.translate(W / 2, fy); g.scale(1, .12);
    var sg = g.createRadialGradient(0, 0, 0, 0, 0, fw); sg.addColorStop(0, 'rgba(0,0,0,.85)'); sg.addColorStop(.6, 'rgba(0,0,0,.35)'); sg.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = sg; g.beginPath(); g.arc(0, 0, fw, 0, 6.2832); g.fill(); g.restore();
    if (sh.floor) { var fl = g.createLinearGradient(W * .06, 0, W * .94, 0); fl.addColorStop(0, 'rgba(255,255,255,0)'); fl.addColorStop(.5, 'rgba(255,255,255,.16)'); fl.addColorStop(1, 'rgba(255,255,255,0)'); g.fillStyle = fl; g.fillRect(W * .06, base, W * .88, 1); }
    var p = 6, x = R.x - p, y = R.y - p, w = R.w + p * 2, h = R.h + p * 2, dep = round ? 0 : (sh.edge ? 3 : 7);
    g.save(); g.shadowColor = 'rgba(0,0,0,.75)'; g.shadowBlur = 36; g.shadowOffsetY = 22;
    if (round) {
      var cx = W / 2, cy = R.y + R.h / 2, r = Math.min(R.w, R.h) / 2 + 2;
      var rg = g.createRadialGradient(cx - r * .4, cy - r * .45, r * .1, cx, cy, r); rg.addColorStop(0, '#1e1e21'); rg.addColorStop(.7, '#0b0b0c'); rg.addColorStop(1, '#040405');
      g.fillStyle = rg; g.beginPath(); g.arc(cx, cy, r, 0, 6.2832); g.fill(); g.restore();
      g.strokeStyle = 'rgba(255,255,255,.14)'; g.lineWidth = 1; g.beginPath(); g.arc(cx, cy, r - .5, Math.PI * 1.05, Math.PI * 1.6); g.stroke();
    } else {
      /* spessore visibile sul lato destro e in basso */
      g.fillStyle = '#050506'; g.beginPath(); g.moveTo(x + w, y); g.lineTo(x + w + dep, y + dep); g.lineTo(x + w + dep, y + h + dep); g.lineTo(x + dep, y + h + dep); g.lineTo(x, y + h); g.lineTo(x + w, y + h); g.closePath(); g.fill();
      var fg = g.createLinearGradient(x, y, x + w * .3, y + h); fg.addColorStop(0, sh.frame ? 'rgba(255,255,255,.05)' : '#1a1a1d'); fg.addColorStop(1, sh.frame ? 'rgba(255,255,255,.015)' : '#0a0a0b');
      g.fillStyle = fg; g.fillRect(x, y, w, h); g.restore();
      var side = g.createLinearGradient(x + w, 0, x + w + dep, 0); side.addColorStop(0, '#111113'); side.addColorStop(1, '#020203');
      g.fillStyle = side; g.beginPath(); g.moveTo(x + w, y); g.lineTo(x + w + dep, y + dep); g.lineTo(x + w + dep, y + h + dep); g.lineTo(x + w, y + h); g.closePath(); g.fill();
      g.fillStyle = 'rgba(255,255,255,' + (sh.frame ? .2 : .13) + ')'; g.fillRect(x, y, w, 1); g.fillStyle = 'rgba(255,255,255,.06)'; g.fillRect(x, y, 1, h);
      if (sh.foot) { var fx = W / 2 - R.w * .8, fw2 = R.w * 1.6; g.fillStyle = '#16161a'; g.fillRect(fx, base - 5, fw2, 5); g.fillStyle = 'rgba(255,255,255,.14)'; g.fillRect(fx, base - 5, fw2, 1); }
      if (sh.frame) { g.strokeStyle = 'rgba(255,255,255,.16)'; g.lineWidth = 1; g.strokeRect(x - 6.5, y - 6.5, w + 13, h + 13); }
    }
  };
  Matrix.prototype.wake = function () { loop(); };
  Matrix.prototype.active = function () { return this.hover || this.hoverT > .01 || this.waves.length > 0; };
  Matrix.prototype.draw = function (now) {
    var g = this.g, sh = this.sh, d = this.dots, W = this.W, H = this.H, R = this.rect;
    /* il contenuto si muove solo mentre il mouse è sopra: a riposo l'immagine è ferma e non pesa sullo scorrimento */
    if (this.active()) this.tt = (this.tt || 0) + .033; var t = this.tt || 0;
    g.clearRect(0, 0, W, H);
    if (this.bg) g.drawImage(this.bg, 0, 0, W, H);
    /* onde */
    var waves = this.waves, live = [];
    for (var w = 0; w < waves.length; w++) if (now - waves[w].t < 1400) live.push(waves[w]);
    this.waves = waves = live;
    this.hoverT += ((this.hover ? 1 : 0) - this.hoverT) * .08;
    var px = this.px, py = this.py, hv = this.hoverT, rad = this.rad, hue = this.hue, reach = Math.max(70, Math.min(W, H) * .42);
    for (var k = 0; k < d.length; k += 6) {
      var x = d[k], y = d[k + 1], u = d[k + 2], v = d[k + 3], lt = d[k + 4], sz = d[k + 5];
      /* contenuto a riposo: un gradiente lento, come un video ambient sullo schermo */
      var f = .5 + .5 * Math.sin(u * 5.2 + t * .55) * Math.cos(v * 3.4 - t * .35);
      var a = (.2 + .34 * f) * lt, glow = 0;
      if (hv > .01) { var dx = x - px, dy = y - py, q = (dx * dx + dy * dy) / (reach * reach); if (q < 4) glow = Math.exp(-q * 2.2) * hv; }
      for (var w2 = 0; w2 < waves.length; w2++) {
        var wv = waves[w2], age = (now - wv.t) / 1000, dist = Math.hypot(x - wv.x, y - wv.y) - age * 360;
        glow += Math.exp(-(dist * dist) / 500) * (1 - age / 1.4) * .7;
      }
      if (glow > 1) glow = 1;
      if (glow > .02) {
        g.fillStyle = 'hsla(' + ((hue + u * 40 + v * 25) % 360).toFixed(0) + ',82%,' + (58 + glow * 14).toFixed(0) + '%,' + Math.min(1, a + glow * .85 * Math.min(1, lt + .2)).toFixed(3) + ')';
      } else {
        g.fillStyle = 'rgba(245,' + (150 + f * 40).toFixed(0) + ',' + (35 + f * 50).toFixed(0) + ',' + a.toFixed(3) + ')';
      }
      g.beginPath(); g.arc(x, y, rad * sz * (1 + glow * .55), 0, 6.2832); g.fill();
    }
  };

  var raf = 0, last = 0;
  function loop() {
    if (raf) return;
    raf = requestAnimationFrame(function step(now) {
      raf = 0;
      if (now - last < 30) { raf = requestAnimationFrame(step); return; }
      last = now; var any = false;
      for (var i = 0; i < all.length; i++) { var m = all[i]; if (m.vis && m.active()) { m.draw(now); any = true; } }
      if (any && !RM) raf = requestAnimationFrame(step);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-lw3d]').forEach(function (box) {
      if (box.__mx) return;
      var m = box.__mx = new Matrix(box); all.push(m);
      if ('IntersectionObserver' in window) {
        if (!io) io = new IntersectionObserver(function (en) { en.forEach(function (e) { var mm = e.target.__mx; if (mm) { mm.vis = e.isIntersecting; if (mm.vis) { if (Math.abs(e.boundingClientRect.width - mm.W) > 2 || Math.abs(e.boundingClientRect.height - mm.H) > 2) mm.size(); else mm.draw(performance.now()); } } }); }, { rootMargin: '80px' });
        io.observe(box);
      } else { m.vis = true; }
    });
    loop();
  }
  var rt = 0;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { all.forEach(function (m) { m.size(); }); }, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
